import React, { useContext } from "react";
import { Dropdown, Icon, Menu, message, Modal } from "antd";
import { AnswerContent, DiscussContent } from "../../../../context";
import { deleteReply, shieldOrCancel, topOrCancel } from "service/discuss";
import { errorMessage, isTrue } from "service/service";
interface Props {
    editUuid: string;
    canEdit: BooleanValue;
}
export function AnswerMange({ editUuid, canEdit }: Props) {
    const { answerData } = useContext(AnswerContent);
    const { updateDiscussDetail, setIsWriting, discussDetail, setEditUuid } =
        useContext(DiscussContent);

    const isTop = isTrue(answerData.isTop);
    const isBlocked = !isTrue(answerData.canShow);

    function onTop() {
        Modal.confirm({
            content: !isTop ? `确定要置顶该回答吗?` : "确定要取消置顶该回答吗?",
            onOk: async () => {
                try {
                    await topOrCancel(answerData.topicUuid, answerData.uuid);
                    updateDiscussDetail();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    }

    function onBlock() {
        Modal.confirm({
            content: !isBlocked
                ? `确定要屏蔽该回答吗? 屏蔽后该回答只有教师可以看到. 可以在 "屏蔽" 标签下取消`
                : "确定要取消屏蔽该回答吗?",
            onOk: async () => {
                try {
                    await shieldOrCancel(answerData.topicUuid, answerData.uuid);
                    updateDiscussDetail();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    }

    function onDelete() {
        Modal.confirm({
            content: "你确定要删除这条评论吗？",
            onOk: async () => {
                try {
                    await deleteReply(answerData.topicUuid, answerData.uuid);
                    message.success("删除成功!");
                    updateDiscussDetail();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    }
    function onEdit() {
        setEditUuid(editUuid);
        setIsWriting(true);
    }

    const menu = (
        <Menu style={{ width: 80, textAlign: "center" }}>
            {isTrue(canEdit) && <Menu.Item onClick={onEdit}>编辑</Menu.Item>}
            {isTrue(canEdit) && <Menu.Item onClick={onDelete}>删除</Menu.Item>}
            <Menu.Item onClick={onTop}>{isTop ? "取消置顶" : "置顶"}</Menu.Item>
            <Menu.Item onClick={onBlock}>
                {isBlocked ? "取消屏蔽" : "屏蔽"}
            </Menu.Item>
        </Menu>
    );

    return (
        <Dropdown overlay={menu} placement="bottomCenter">
            <Icon type="more" />
        </Dropdown>
    );
}
